import type { ReactNode } from "react";

type Props = {
  top?: ReactNode;
  left?: ReactNode;
  leftBottom?: ReactNode;
  right?: ReactNode;
  bottom?: ReactNode;
};

export function Layout({ top = <></>, left, right = <></>, leftBottom, bottom }: Props) {
  return (
    <div>
      {top}
      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-x-32">
        <div className="md:col-span-2">{left}</div>
        <div className="md:col-span-1 md:row-span-2">{right}</div>
        {leftBottom ? <div className="md:col-span-2">{leftBottom}</div> : null}
        {bottom ? <div className="md:col-span-2">{bottom}</div> : null}
      </div>
    </div>
  );
}
